import React from 'react'
import styled from 'styled-components'
import { Avatar, Block } from '@mote/ui'

export const ThemeSkeleton = ({
  avatarUrl = '',
  userName = '',
  theme = {}
}) => {
  return (
    <Root background={theme.styles.background}>
      <Block gap={15} style={{ padding: '59px 0 54px 0' }} align='center'>
        <Avatar text={userName} size={42} fontSize={16} url={avatarUrl} />
        <Block gap={5} align='center'>
          <Placeholder
            width={88}
            height={13}
            background={theme.styles.placeholderBackground}
          />
          <Placeholder
            width={107}
            height={13}
            background={theme.styles.placeholderBackground}
          />
        </Block>
      </Block>

      <Block gap={10} style={{ padding: '0 8px' }}>
        <Placeholder
          height={3}
          width={223}
          background={theme.styles.placeholderBackground}
        />
        <Block layout='horizontal' gap={4}>
          <Placeholder
            width={16}
            height={16}
            background={theme.styles.placeholderBackground}
            radius={50}
          />
          <Placeholder
            width={16}
            height={16}
            background={theme.styles.placeholderBackground}
            radius={50}
          />
          <Placeholder
            width={16}
            height={16}
            background={theme.styles.placeholderBackground}
            radius={50}
          />
          <Placeholder
            width={16}
            height={16}
            background={theme.styles.placeholderBackground}
            radius={50}
          />
        </Block>
      </Block>
    </Root>
  )
}

const Root = styled.div`
  height: 240px;
  width: 240px;
  background: ${({ background }) => background};
`

const Placeholder = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background: ${({ background }) => background};
  border-radius: ${({ radius }) => radius ?? 0}%;
`
